module.exports = __webpack_public_path__ + "static/media/restaurant-placeholder.94fbd9ec.jpg";